module.exports = __webpack_public_path__ + "img/attachment-icon-plus.1e60a3ad.png";